"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DESIGN_SERVICE_API_VERSION = exports.CURRENT_PROJECT_VERSION = void 0;
exports.CURRENT_PROJECT_VERSION = 12;
exports.DESIGN_SERVICE_API_VERSION = 5;
